import { CartState } from '@ph-shopping/store/cart/cart-store.types';
import { ProductState } from '@ph-shopping/store/product/product.store';
import { VehicleState } from '@ph-shopping/store/vehicle/vehicle.store';
import { UserState } from '@ph-store/user/user.store';

import { GetProductsRequest } from '../product.request';

export class SaveQuote {
  VehicleState: VehicleState;
  cartState: CartState;
  userState: UserState;
  getProductRequest: GetProductsRequest;
  productState?: ProductState;

  constructor(
    getProductsRequest: GetProductsRequest,
    vehicleState: VehicleState,
    cartState: CartState,
    userState: UserState
  ) {
    this.userState = userState;
    this.VehicleState = vehicleState;
    this.cartState = cartState;
    this.getProductRequest = getProductsRequest;
  }
}
